import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-13afd1b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animate register" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Registrarme", -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-space" }, "Nombre completo", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Este será el nombre que aparecerá en los diplomas de las certificaciones que obtengas. Asegúrate de introducir el nombre completo deseado.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-space" }, "Email", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "El email será necesario para cualquier problema que puedas tener. Asegúrate de introducirlo correctamente.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-space" }, "Contraseña", -1))
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-space" }, "Repetir contraseña", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Introduce una contraseña segura. Son válidos todos los caracteres alfanuméricos. Evita usar tildes o eñes.", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_17 = { class: "form-group check" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  required: "",
  checked: ""
}, null, -1))
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "feedback" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "long-spacer" }, null, -1))

import { ref } from 'vue'
import { useAuth } from '@/store/useAuth'
import router from '@/router'
import main from '@/data/main.js';

export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterForm',
  setup(__props) {

const store = useAuth()

const feedback = ref('')
const name = ref('')
const email = ref('')
const password = ref('')
const repeatPassword = ref('')

function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
    window.gtag('event', 'conversion', {
        'send_to': 'AW-11153245589/-ykTCNCj-psYEJWLpMYp',
        'event_callback': callback
    });
    return false;
  }

const handleRegister = async () => {
    feedback.value = "Enviando datos..."

    if(repeatPassword.value != password.value) {
        feedback.value = "Las contraseñas no coinciden."
        return
    }
    try {
        const success = await store.register(name.value, email.value, password.value)
        if(!success) {
            feedback.value = "Error. " + store.message
            return
        }

        gtag_report_conversion()
        feedback.value = "Éxito. Cargando tu panel de estudios..."
        router.push({name: 'home'})

    } catch(e) {
        feedback.value = "El servidor se ha ido de vacaciones. Por favor, inténtalo más tarde."
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Nombre y Apellidos",
          required: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event))
        }, null, 512), [
          [_vModelText, name.value]
        ]),
        _hoisted_5
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "demo@ademass.com",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event))
        }, null, 512), [
          [_vModelText, email.value]
        ]),
        _hoisted_9
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          required: "",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event))
        }, null, 512), [
          [_vModelText, password.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          required: "",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((repeatPassword).value = $event))
        }, null, 512), [
          [_vModelText, repeatPassword.value]
        ]),
        _hoisted_15
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createTextVNode(),
        _createElementVNode("small", null, [
          _createTextVNode("He leído y acepto el "),
          _createElementVNode("a", {
            href: _unref(main).LEGAL_NOTICE,
            target: "_blank"
          }, "aviso legal", 8, _hoisted_19),
          _createTextVNode(", "),
          _createElementVNode("a", {
            href: _unref(main).PRIVACY_POLICY,
            target: "_blank"
          }, " política de privacidad", 8, _hoisted_20),
          _createTextVNode(" y "),
          _createElementVNode("a", {
            href: _unref(main).TERMS_OF_USE,
            target: "_blank"
          }, "términos de uso.", 8, _hoisted_21)
        ])
      ]),
      _createElementVNode("input", {
        type: "submit",
        value: "Comenzar mi formación",
        class: "go-btn",
        onClick: _withModifiers(handleRegister, ["prevent"])
      }),
      _createElementVNode("p", _hoisted_22, _toDisplayString(feedback.value), 1),
      _hoisted_23
    ])
  ]))
}
}

})